import { Button, Tooltip } from '@nextui-org/react';
import React, { FC, useEffect, useState } from 'react';
import { FaFileUpload, FaSignOutAlt, FaUserAlt } from 'react-icons/fa';
import { FaBoxesPacking, FaTableList } from 'react-icons/fa6';
import { LuMove3D } from 'react-icons/lu';
import { useLocation, useNavigate } from 'react-router-dom';
import { logOut } from '../../redux/features/generalData/generalDataSlice';
import { useAsyncDispatch } from '../../redux/store';

export interface SideMenuOption {
  icon: JSX.Element;
  name: string;
  path: string;
}

export interface SideMenuProps {
  isOpen: boolean;
}

const SideMenu: FC<SideMenuProps> = ({ isOpen }): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAsyncDispatch();
  const { pathname } = useLocation();
  const [selectedMenuButton, setSelectedMenuButton] = useState<string>('');
  const menus: SideMenuOption[] = [
    {
      icon: <FaFileUpload className="h-6 w-6" />,
      name: 'Notfis FAST',
      path: '/notfis-fast',
    },
    {
      icon: <FaBoxesPacking className="h-6 w-6" />,
      name: 'Etiquetar',
      path: '/Etiquetar',
    },
    {
      icon: <FaTableList className="h-6 w-6" />,
      name: 'Listar Notfis',
      path: '/consultar-notfis',
    },
    {
      icon: <LuMove3D className="h-6 w-6" />,
      name: 'Cubagem',
      path: '/cubagem',
    },
    {
      icon: <FaUserAlt className="h-6 w-6" />,
      name: 'Parceiros',
      path: '/parceiros',
    },
  ];

  useEffect(() => {
    const menu = menus.find(({ path }) => pathname.includes(path));
    setSelectedMenuButton(menu?.name ?? '');
  }, [pathname]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
      className={`mt-8 w-full overflow-hidden transition-[max-width] duration-250 ${
        isOpen ? 'max-w-[200px]' : 'max-w-[64px]'
      }`}
    >
      <div>
        {menus.map((menu) => (
          <Tooltip
            key={menu.name}
            showArrow
            placement="right"
            color="foreground"
            content={menu.name}
            isDisabled={isOpen}
            className="rounded px-4 py-2"
            offset={-12}
          >
            <Button
              variant={selectedMenuButton === menu.name ? 'solid' : 'ghost'}
              onPress={() => navigate(menu.path)}
              className="group flex w-full flex-row items-center justify-start gap-4 rounded-none border-none px-5 py-8"
            >
              <div
                className={`text-foreground-400 group-hover:text-foreground-800 ${
                  selectedMenuButton === menu.name ? 'text-foreground-800' : ''
                }`}
              >
                {menu.icon}
              </div>

              <p
                className={`font-semibold text-foreground-400 transition-opacity group-hover:text-foreground-800 ${
                  selectedMenuButton === menu.name ? 'text-foreground-800' : ''
                } ${isOpen ? 'opacity-100' : 'opacity-0'}`}
              >
                {menu.name}
              </p>
            </Button>
          </Tooltip>
        ))}
      </div>
      <Button
        variant={selectedMenuButton === 'SignOut' ? 'solid' : 'ghost'}
        onPress={() => dispatch(logOut())}
        className="group flex w-full flex-row items-center justify-start gap-4 rounded-none border-none px-5 py-8"
      >
        <div
          className={`text-foreground-400 group-hover:text-foreground-800 ${
            selectedMenuButton === 'SignOut' ? 'text-foreground-800' : ''
          }`}
        >
          <FaSignOutAlt size={20} />
        </div>

        <p
          className={`font-semibold text-foreground-400 transition-opacity group-hover:text-foreground-800 ${
            selectedMenuButton === 'SignOut' ? 'text-foreground-800' : ''
          } ${isOpen ? 'opacity-100' : 'opacity-0'}`}
        >
          LogOut
        </p>
      </Button>
    </div>
  );
};

export default SideMenu;
